<div class="ui-toggle-row">
  <span class="ui-toggle-title" *ngIf="label && !labelAfter">{{ label }}</span>
  <button
    type="button"
    role="switch"
    class="ui-toggle-switch"
    [class.is-on]="checked"
    [attr.aria-checked]="checked"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel || label"
    (click)="onToggle()"
  >
    <span class="ui-toggle-knob"></span>
  </button>
  <span class="ui-toggle-title" *ngIf="label && labelAfter">{{ label }}</span>
  <span *ngIf="showState" class="ui-toggle-state" [class.is-on]="checked">{{ checked ? 'Enabled' : 'Disabled' }}</span>
</div>
